import {Modal} from "bootstrap";

export function showModalById(id) {
    const modalElement = document.getElementById(id)
    if (modalElement) {
        const instance = new Modal(modalElement)
        instance.show()
    }
}

export function hideModalById(id) {
    const modalElement = document.getElementById(id)
    if (modalElement) {
        const instance = Modal.getInstance(modalElement) || new Modal(modalElement)
        instance.hide()
    }
}
export function showAndBindModal(modalId, onHidden, params) {
    const el = document.getElementById(modalId)
    if (!el) return null

    const modalInstance = new Modal(el, params)
    modalInstance.show()

    const handleHidden = () => {
        onHidden?.()
        modalInstance.dispose()
        el.removeEventListener('hidden.bs.modal', handleHidden)
    }

    el.addEventListener('hidden.bs.modal', handleHidden)

    return modalInstance
}

export function safelyHideModal(modalId, modalInstance) {
    if (!modalInstance) return
    const el = document.getElementById(modalId)
    if (el) {
        modalInstance.hide()
    }
}